/*eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
export default {
  name: 'uploadsolutionform',
  components: {},
  props: [],
  data () {
    return {
      assignmentComment: '',
      comment: '',
      respondId: '',
      fileValue: [],
      filename: '',
      commentName: '',
      commentWthImg: '',
      file: null,
      assignmentForm:[{
        assignmentFile: '',
        assignmentName: '',
        assignmentComment: ''
      }],

    }
  },
  computed: {
    checkSolutionExist(){
      if(this.$store.state.assignmentStore.singleAssignmentState.solution.length != '0'){
        
        this.respondId = this.$store.state.assignmentStore.singleAssignmentState.solution[0].id;
        this.assignmentComment = this.$store.state.assignmentStore.singleAssignmentState.solution[0].comment
        return;
      }else{
        this.respondId = '';
        this.assignmentComment = ''
      }
     
    },
  },
  mounted () {
    this.checkSolutionExist();
  },
  created(){
  },
  methods: {
    
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let dataComment = {
            comment: this.comment,
            assignment: this.$route.params.id
          }
          this.$store.dispatch('addCommentResponse', dataComment).then((res) => {
            
           if(res.status == 201){
            
            this.$store.dispatch('getSignleAssignmentActn', {id: this.$route.params.id}).then((res) => {
              
                this.respondId = this.$store.assignmentStore.singleAssignmentState.solution[0].id;
                this.assignmentComment = this.$store.assignmentStore.singleAssignmentState.solution[0].comment;;
            }).catch((err) => {
            })
            
                
                toast.success(res.data.msg);
            
           }else{ 
            toast.error(res.data.msg);
           } 
          }).catch((err) => {})

          return
        }
      })
    },
    addAssignementForm(){
       this.assignmentForm.push({
        assignmentFile: '',
        assignmentName: '',
        assignmentComment: ''
      })
    },
    getAssignmentAgain(){
      this.$store.dispatch('getSignleAssignmentActn', {id: this.$route.params.id}).then((res) => {
       
      }).catch((err) => {
      })
    },

    deleteAssignmentForm(index){
      this.assignmentForm.splice(index, 1)
    }, 

    handleFileUpload(event, index){ 
      // this.fileValue = this.$refs.assignmentFile[index].files[0];
      if(this.$refs.assignmentFile[index].files[0].size > 525848){
        alert('file size is exceed');
        this.$refs.assignmentFile[index].value = '';
      }else{
        this.fileValue = this.$refs.assignmentFile[index].files[0];
        this.$refs.filename[index].value = this.fileValue.name;
     
        this.$refs.assignmentName[index].value = this.fileValue.name;
        
        $('#filename'+index).html(this.$refs.filename[index].value);
      }
       
       
    },
 
    validateAssignmentBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          for(var i = 0; i < this.assignmentForm.length; i++){
            let formdata = new FormData();
            formdata.append('file', this.$refs.assignmentFile[i].files[0]);
            formdata.append('name', this.$refs.assignmentName[i].value);
            formdata.append('comment', this.$refs.assignmentComment[i].value);
            formdata.append('assignment_solution', this.respondId);
              this.$store.dispatch('addSolutionFileResponse', formdata).then((res) => {
                if(res.status == '201'){
                  this.getAssignmentAgain();
                  this.comment = '';
                  this.assignmentForm=[{
                    assignmentFile: '',
                    assignmentName: '',
                    assignmentComment: ''
                  }],
                  this.filename = '';
                  $('.filename').html('');
                  $('input').val('');
                  this.$validator.reset();
                }
              })
          }
          return   
        }
      });
    }

  },
  watch: {
    checkSolutionExist(){
      if(this.$store.state.assignmentStore.singleAssignmentState.solution.length != '0'){
        this.respondId = this.$store.state.assignmentStore.singleAssignmentState.solution[0].id
      }else{
        this.respondId = '';
      }
    },
  }
}
